import React from 'react';
import {
  IconCalendarTime,
  IconCalendarEvent,
  IconPackage,
  IconClipboardText,
} from '@tabler/icons-react';
import {
  MESSAGE_TYPE,
  PENDING_MESSAGE_TYPE,
  getInteractiveMessageLabel,
} from '@entities/messanger';
import { EntityCard } from './entity-card';
import { SlotOfferEntityCard } from './slot-offer-entity-card';
import { PackageOfferEntityCard } from './package-offer-entity-card';
import { AppointmentEntityCard } from './appointment-entity-card';
import { SlotOfferCard } from './slot-offer-card';
import { PackageOfferCard } from './package-offer-card';
import s from './interactive-message.module.scss';

// Иконка карточки по типу сообщения
const TYPE_ICONS = {
  [MESSAGE_TYPE.SLOT_OFFER]: <IconCalendarTime size={20} />,
  [MESSAGE_TYPE.APPOINTMENT_CARD]: <IconCalendarEvent size={20} />,
  [MESSAGE_TYPE.PACKAGE_CARD]: <IconPackage size={20} />,
  [MESSAGE_TYPE.PACKAGE_OFFER_CARD]: <IconPackage size={20} />,
};

const getTypeIcon = (type) => TYPE_ICONS[type] || <IconClipboardText size={20} />;

// Диспетчер интерактивных сообщений.
// Сервер присылает готовый UI-контракт в message.card — рендерим его.
// Если card нет (наше pending-сообщение до подтверждения), показываем
// fallback по payload.
export const InteractiveMessage = ({ message, isMine }) => {
  if (message.type === MESSAGE_TYPE.SLOT_OFFER && message.card) {
    return <SlotOfferEntityCard message={message} />;
  }

  if (message.type === MESSAGE_TYPE.APPOINTMENT_CARD && message.card) {
    return <AppointmentEntityCard message={message} />;
  }

  if (message.type === MESSAGE_TYPE.PACKAGE_OFFER_CARD && message.card) {
    return <PackageOfferEntityCard message={message} />;
  }

  if (message.card) {
    return (
      <EntityCard
        card={message.card}
        message={message}
        icon={getTypeIcon(message.type)}
      />
    );
  }

  switch (message.type) {
    case MESSAGE_TYPE.SLOT_OFFER:
    case PENDING_MESSAGE_TYPE.SLOT_OFFER:
      return <SlotOfferCard message={message} isMine={isMine} />;
    case PENDING_MESSAGE_TYPE.PACKAGE_OFFER:
      return <PackageOfferCard message={message} isMine={isMine} />;
    default:
      return (
        <span className={s.statusText}>
          {getInteractiveMessageLabel(message.type)}
        </span>
      );
  }
};
